const { default: axiosIns } = require('@/libs/axios')

const ConfigurationService = {
  async getConfigurations() {
    // GET - ConfigurationApiController
    return axiosIns.get('/configurations').then(response => response.data)
  },
}

export default ConfigurationService
